import { isNonEmptyString } from '@/utils/checks'
import { isFacetPageType, isLocationPageType } from './pageTypeCheck'
import { PageType } from '@/types/models/PageType.model'

interface GetPageTypeName {
  (pageType: PageType): string
}

const getPageTypeName: GetPageTypeName = (pageType = '') => {
  if (!isNonEmptyString(pageType)) {
    return ''
  }

  if (isFacetPageType(pageType)) {
    return 'Facet'
  }
  if (isLocationPageType(pageType)) {
    return 'Location'
  }

  return pageType
}

export default getPageTypeName
